<template>
  <b-container>
    <b-nav class="w-100" justified pills>
      <b-nav-item to="/">
        <h4>
          <b-icon-cloud-upload-fill :variant="onUploadRoute($route.name) ? 'primary' : null"></b-icon-cloud-upload-fill><br />
          Upload
        </h4>
      </b-nav-item>
      <b-nav-item to="/upload-history">
        <h4>
          <b-icon-clock-history :variant="$route.name === 'Upload History' ? 'primary' : null"></b-icon-clock-history><br />
          Upload History
        </h4>
      </b-nav-item>
      <b-nav-item to="/preferences">
        <h4>
          <b-icon-tools :variant="$route.name === 'Preferences' ? 'primary' : null"></b-icon-tools><br />
          Preferences
        </h4>
      </b-nav-item>
    </b-nav>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { BIcon, BIconCloudUploadFill, BIconClockHistory, BIconTools, BNav, BNavItem, LayoutPlugin } from 'bootstrap-vue'
import { OnUploadRoute } from '@/router'

Vue.use(LayoutPlugin)

@Component({
  components: {
    BIconCloudUploadFill,
    BIconClockHistory,
    BIconTools,
    BIcon,
    BNav,
    BNavItem
  }
})
export default class Navigation extends Vue {
  onUploadRoute = OnUploadRoute
}
</script>

<style lang="scss">
.nav-item a {
  padding: 0;
}
</style>
